<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="1300_auto"
      :loading="loading.content"
      :visible.sync="modalVisible">
    <template #header>
      <div v-html="header" class="header"></div>
      <gj-tag
          v-if="editOpType || viewOpType"
          type="plain"
          shape="rectangle"
          :color="purchaseOrder.status | optionColor(PurchaseOrderEnum.statusOption)">
        {{ purchaseOrder.status | optionText(PurchaseOrderEnum.statusOption) }}
      </gj-tag>
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="label1Width" />
        <gj-input v-model="inputWidth" />
      </div>
      <div class="step-wrapper">
        <gj-steps
            :active="curStep"
            :steps="steps">
          <template v-for="(item, index) in stepTplList"
                    v-slot:[item.descriptionTpl]>
            <div :key="index" v-if="item.descriptionTpl !== 'complete'">
              <div>
                <i class="el-icon-user-solid"></i>
                <span> {{item.opUserContent}}</span>
              </div>
              <div>
                <i class="el-icon-time"></i>
                <span> {{item.opTimeContent}}</span>
              </div>
            </div>
          </template>
        </gj-steps>
      </div>
      <el-form
          ref="form"
          :model="form"
          :class="{'view-form': viewOpType}"
          :label-width="labelWidth">
        <gj-area-title>供应商信息</gj-area-title>
        <template v-if="addOpType || editOpType">
          <el-row>
            <el-col :span="8">
              <el-form-item
                  label="供应商"
                  prop="supplierCode"
                  :rules="[
                  { required: true, message: '请选择供应商', trigger: ['change'] },
                ]"
                  :label-width="label1Width">
                <gj-supplier-select
                    v-model="form.supplierCode"
                    :width="inputWidth"
                    active
                    placeholder="供应商"
                ></gj-supplier-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                  label="供应商联系人"
                  prop="supplierContact"
                  :label-width="label1Width">
                <gj-input
                    v-model="form.supplierContact"
                    :width="inputWidth"
                    placeholder="供应商联系人"
                ></gj-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                  label="联系人电话"
                  prop="supplierContactPhone"
                  :label-width="label1Width">
                <gj-input
                    v-model="form.supplierContactPhone"
                    :width="inputWidth"
                    placeholder="联系人电话"
                ></gj-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                  :label-width="label1Width"
                  label="结算方式"
                  prop="settlementWay">
                <gj-select
                    v-model="form.settlementWay"
                    :width="inputWidth"
                    :options="PurchaseOrderEnum.settleOption"
                    placeholder="结算方式"
                ></gj-select>
              </el-form-item>
            </el-col>

          </el-row>
          <div>
            <gj-area-title>公司信息</gj-area-title>
            <el-row>
              <el-col :span="8">
                <el-form-item label="公司名称" :label-width="label1Width">
                  <gj-input disabled v-model="form.companyName" :width="inputWidth" placeholder="无"></gj-input>
                  <span class="settting-companyName_icon" @click="settingCompany" v-if="$permission('userCompany:view')">
                    <i class="el-icon-setting"></i>
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="采购仓"
                  prop="deliveryWarehouseId"
                  :label-width="label1Width"
                  :rules="[
                  $gjRequired('请选择采购仓'),
                ]">
                <gj-warehouse-select
                    v-model="form.deliveryWarehouseId"
                    :width="inputWidth"
                    :fixedWidth="'100%'"
                    :fba="false"
                    active
                    placeholder="采购仓"
                ></gj-warehouse-select>
              </el-form-item>
              </el-col>
              <el-col :span="8">
              <el-form-item
                  label="采购员"
                  prop="supervisorId"
                  :label-width="label1Width">
                <gj-creator-select
                    v-model="form.supervisorId"
                    :width="inputWidth"
                    active
                    placeholder="采购员"
                ></gj-creator-select>
              </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="收货人姓名" :label-width="label1Width">
                  <gj-select
                  :disabled="!companyInfo.length"
                  :options="companyInfo"
                  :width="inputWidth"
                  v-model="form.consigneeName"
                  @change="consigneeNameChange"></gj-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货人电话" :label-width="label1Width">
                  <gj-input
                  :disabled="!companyInfo.length && !form.phone"
                  placeholder="收货人电话"
                  :width="inputWidth"
                  maxlength="50"
                  v-model="form.phone"></gj-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货地址" :label-width="label1Width">
                  <gj-input
                  :disabled="!companyInfo.length && !form.receiptAddress"
                  placeholder="收货地址"
                  maxlength="50"
                  :width="inputWidth"
                  v-model="form.receiptAddress"></gj-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-form-item
              label="备注"
              :label-width="label1Width"
              prop="memo">
            <gj-input
                v-model="form.memo"
                width="100%">
            </gj-input>
          </el-form-item>
          <el-form-item
              :label-width="label1Width"
              label="上传附件"
              prop="desc">
            <gj-upload
                upload-btn-type="default"
                :container-biz-id="purchaseOrder ? purchaseOrder.id : null"
                container-type="PURCHASE_ORDER"
                :acceptType="[]"
                :fileList.sync="form.files"
                specialUpload
            ></gj-upload>
          </el-form-item>
        </template>
        <template v-else>
          <gj-desc-group
              :label-width="labelWidth">
            <el-row>
              <el-col :span="8">
                <gj-desc label="供应商">{{data.supplierName | defaultShow}}</gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc label="结算方式">{{data.settlementWay | optionText(PurchaseOrderEnum.settleOption) | defaultShow}}</gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc label="供应商联系人">{{data.supplierContact | defaultShow}}</gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc label="联系人电话">{{data.supplierContactPhone | defaultShow}}</gj-desc>
              </el-col>
            </el-row>
            <el-row v-if="purchaseOrder.status === StatusEnum.REJECTED">
              <gj-desc label="驳回理由">{{data.reason | defaultShow}}</gj-desc>
            </el-row>
            <div style="margin-top: 12px;">
              <gj-area-title>公司信息</gj-area-title>
              <el-row>
                <el-col :span="8">
                  <gj-desc label="公司名称">{{data.companyName | defaultShow}}</gj-desc>
                </el-col>
                <el-col :span="8">
                  <gj-desc label="采购仓">{{data.deliveryWarehouseName | defaultShow}}</gj-desc>
                </el-col>
                <el-col :span="8">
                  <gj-desc label="采购员">{{data.supervisor | defaultShow}}</gj-desc>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <gj-desc label="收货人姓名">{{data.consigneeName | defaultShow}}</gj-desc>
                </el-col>
                <el-col :span="8">
                  <gj-desc label="收货人电话">{{data.phone | defaultShow}}</gj-desc>
                </el-col>
                <el-col :span="8">
                  <gj-desc label="收货地址">{{data.receiptAddress | defaultShow}}</gj-desc>
                </el-col>
              </el-row>
              <el-row>
                <gj-desc label="备注">{{data.memo | defaultShow}}</gj-desc>
              </el-row>
              <el-row>
                <gj-desc label="附件">
                  <template v-if="form.files && form.files.length > 0">
                    <gj-link
                        v-for="item in form.files"
                        :key="item.id"
                        @click="download(item.attId)"
                        style="margin-right: 8px;">
                      {{item.name}}
                    </gj-link>
                  </template>
                  <template v-else>-</template>
                </gj-desc>
              </el-row>
            </div>
          </gj-desc-group>
        </template>
      </el-form>

      <!-- 详情 -->
      <template v-if="addOpType || editOpType">
        <app-op-purchase-order-product
            ref="productForm"
            :form="form"
            :op-type="opType"
            :purchase-order="purchaseOrder"
            :mount-to="$mountTo"
        ></app-op-purchase-order-product>
      </template>
      <template v-else>
        <el-tabs value="product">
          <el-tab-pane label="产品明细" name="product">
            <app-op-purchase-order-product
                :form="form"
                :op-type="opType"
                :purchase-order="purchaseOrder"
                :mount-to="$mountTo"
            ></app-op-purchase-order-product>
          </el-tab-pane>
          <template v-if="purchaseOrder.status !== PurchaseOrderEnum.status.DRAFT
            && purchaseOrder.status !== PurchaseOrderEnum.status.WAIT_REVIEW
            && purchaseOrder.status !== PurchaseOrderEnum.status.REJECTED">
            <el-tab-pane label="交货明细" name="delivery" lazy>
              <app-op-purchase-order-delivery
                  :purchase-order="purchaseOrder"
              ></app-op-purchase-order-delivery>
            </el-tab-pane>
            <el-tab-pane label="入库明细" name="inbound" lazy>
              <app-op-purchase-order-inbound
                  :purchase-order="purchaseOrder"
              ></app-op-purchase-order-inbound>
            </el-tab-pane>
          </template>
          <el-tab-pane label="操作日志" name="log" lazy>
            <gj-log-table
                url="/supply/purchaseOrder/get/log/page"
                :params="{
                  model: purchaseOrder.id
                }"
                class="op-purchase-order-modal_logtable"
                :columns="PurchaseOrderEnum.logColumns"
                :min-height="300"
                :offset-height="55"
            ></gj-log-table>
          </el-tab-pane>
        </el-tabs>
      </template>
    </template>
    <template #footer>
      <template v-for="config in btnConfig">
        <gj-button
            v-if="!config.show || config.show()"
            :key="config.label"
            :type="config.type"
            :loading="config.loading && config.loading()"
            @click="config.click"
        >{{config.label}}</gj-button>
      </template>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin} from "@/minxins";
  import AppOpPurchaseOrderProduct from "./components/product/op-purchase-order-product";
  import AppOpPurchaseOrderDelivery from "./components/delivery/op-purchase-order-delivery";
  import AppOpPurchaseOrderInbound from "./components/inbound/op-purchase-oder-inbound";
  import {PurchaseOrderEnum} from "../../enum";
  import {
    auditFailPurchaseOrder, auditPassPurchaseOrder, auditPurchaseOrder,
    cancelPurchaseOrder, endDeliveryPurchaseOrder,
    getPurchaseOrder, getPurchaseOrderProcessList, getPurchaseOrderProductList,
    getSupplierByCode, purchasePurchaseOrder,
    saveAndAuditPurchaseOrder,
    savePurchaseOrder, updateAndAuditPurchaseOrder, updatePurchaseOrder
  } from "@/api/purchase";
  import {convertToDate} from "@/utils/date.util";
  import {downloadAttFile, exportFile} from "@/api/common";
  import AppPurchaseChangeModal from "../change/purchase-change-modal";
  import AppFastInboundModal from "../inbound/fast-inbound-modal";
  import AppCreateDeliveryOrderModal from "../delivery/create-delivery-order-modal";
  import {isMeaningful} from "@/utils/common";
  import { mapGetters } from 'vuex'
  import {
    GET_COMPANY_INFO
   } from '@/store/mutation-types'
  const StatusEnum = PurchaseOrderEnum.status;
  export default {
    name: "app-op-purchase-order-modal",
    components: {AppOpPurchaseOrderInbound, AppOpPurchaseOrderDelivery, AppOpPurchaseOrderProduct},
    mixins: [modalMixIn, formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin],
    props: {
      header: {
        required: true
      },
      opType: {
        required: true
      },
      purchaseOrder: {
        default: null
      }
    },
    data() {
      return {
        data: {},
        form: {
          id: null,
          deliveryWarehouseId: null,
          supplierCode: null,
          supervisorId: null,
          settlementWay: null,
          supplierContact: null,
          supplierContactPhone: null,
          memo: null,
          files: [],
          products: [],
          // 公司名称
          companyName: '',
          // 收货人姓名
          consigneeName: '',
          // 收货人电话
          phone: '',
          // 收货地址
          receiptAddress: ''
        },

        labelWidth: '100px',
        label1Width: '130px',
        inputWidth: '100%',
        curStep: 0,
        steps: [],
        loading: {
          saveAsDraft: false,
          saveAndAudit: false,
          edit: false,
          pass: false,
          content: false
        },
        PurchaseOrderEnum: PurchaseOrderEnum,
        StatusEnum: StatusEnum,
        initing: false,
        btnConfig: [
          {
            label: '取消',
            click: () => this.cancel()
          },
          {
            label: '保存为草稿',
            show: () => (this.addOpType || (this.editOpType && this.purchaseOrder.status === StatusEnum.DRAFT))
              && this.$permission('purchaseOrder:add'),
            loading: () => this.loading.saveAsDraft,
            click: () => this.saveAsDraft()
          },
          {
            label: '作废',
            show: () => this.editOpType
              && this.$permission('purchaseOrder:abolish')
              && this.purchaseOrder.status === StatusEnum.REJECTED,
            click: () => this.deleteItem()
          },
          {
            label: '提审',
            show: () => (this.addOpType || (this.editOpType && (this.purchaseOrder.status === StatusEnum.DRAFT || this.purchaseOrder.status === StatusEnum.REJECTED)))
              && this.$permission('purchaseOrder:audit'),
            type: 'primary',
            loading: () => this.loading.saveAndAudit,
            click: () => this.saveAndAudit()
          },
          {
            label: '作废',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:abolish')
              && this.someIs(this.purchaseOrder.status, [StatusEnum.DRAFT, StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED, StatusEnum.WAIT_ORDER, StatusEnum.WAIT_ARRIVE]),
            click: () => this.deleteItem()
          },
          {
            label: '提审',
            show: () => this.viewOpType
              && (this.purchaseOrder.status === StatusEnum.DRAFT || this.purchaseOrder.status === StatusEnum.REJECTED)
              && this.$permission('purchaseOrder:audit'),
            type: 'primary',
            loading: () => this.loading.saveAndAudit,
            click: () => this.audit()
          },
          {
            label: '导出合同',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:exportContract')
              && this.someIs(this.purchaseOrder.status, [StatusEnum.WAIT_REVIEW, StatusEnum.WAIT_ORDER, StatusEnum.WAIT_ARRIVE, StatusEnum.COMPLETED]),
            click: () => this.exportContract()
          },
          {
            label: '审核驳回',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:audit')
              && this.purchaseOrder.status === StatusEnum.WAIT_REVIEW,
            click: () => this.fail()
          },
          {
            label: '审核通过',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:audit')
              && this.purchaseOrder.status === StatusEnum.WAIT_REVIEW,
            type: 'primary',
            click: () => this.pass()
          },
          {
            label: '采购变更',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:createPurchaseChangeOrder')
              && this.someIs(this.purchaseOrder.status, [StatusEnum.WAIT_ORDER, StatusEnum.WAIT_ARRIVE, StatusEnum.COMPLETED]),
            click: () => this.purchaseChange()
          },
          {
            label: '下单',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:add')
              && this.purchaseOrder.status === StatusEnum.WAIT_ORDER,
            type: 'primary',
            click: () => this.purchase()
          },
          {
            label: '结束交货',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:endDeliveryNote')
              && this.purchaseOrder.status === StatusEnum.WAIT_ARRIVE,
            click: () => this.endDelivery()
          },
          {
            label: '快捷入库',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:fastInbound')
              && this.purchaseOrder.status === StatusEnum.WAIT_ARRIVE
              && this.purchaseOrder.totalOrderQuantity > this.purchaseOrder.totalAlreadyDeliveryQuantity,
            click: () => this.fastInbound()
          },
          {
            label: '创建交货单',
            show: () => this.viewOpType
              && this.$permission('purchaseOrder:addDeliveryNote')
              && this.purchaseOrder.status === StatusEnum.WAIT_ARRIVE
              && this.purchaseOrder.totalOrderQuantity > this.purchaseOrder.totalAlreadyDeliveryQuantity,
            type: 'primary',
            click: () => this.createDeliveryOrder()
          },
        ]
      }
    },
    watch: {
      'form.deliveryWarehouseId': {
        handler: function (newVal, oldVal) {
          if (this.initing) {
            return;
          }
          if (newVal !== oldVal) {
            this.form.products = [];
          }
        }
      },
      'form.supplierCode': {
        handler: function (supplierCode, oldVal) {
          if (this.initing) {
            return;
          }
          if (supplierCode !== oldVal) {
            this.form.products = [];
          }
          getSupplierByCode(supplierCode)
            .then(data => {
              if (data) {
                this.form.settlementWay = data.settlementWay;
                this.form.supplierContact = data.contact;
                this.form.supplierContactPhone = data.contactPhone;
              }
            });
        }
      },
      companyInfo(val) {
        if (val.length) {
          this.setCompanyInfo(val)
          const instance = val.find(v => v.consignee === this.form.consigneeName)
          this.setconsignee(instance || {})
        }
      }
    },
    computed: {
      formParams() {
        return {
          ...this.form,
          fileIdList: this.form.files.map(item => item.attId),
          files: null,
          products: this.form.products.map(item => ({
            ...item,
            expectDeliveryDate: convertToDate(item.expectDeliveryDate)
          })),
        }
      },
      stepTplList() {
        return this.steps.filter(item => isMeaningful(item.descriptionTpl));
      },
      ...mapGetters(['companyInfo']),
    },
    created() {
      // 正常流程
      const normalSteps = [
        {
          id: 'create',
          title: '创建',
          opUserLabel: '创建人',
          opTimeLabel: '创建时间'
        },
        {
          id: 'review',
          title: '审核',
          opUserLabel: '审核人',
          opTimeLabel: '审核时间'
        },
        {
          id: 'placeAnOrder',
          title: '下单',
          opUserLabel: '操作人',
          opTimeLabel: '操作时间'
        },
        {
          id: 'delivery',
          title: '交货',
          opUserLabel: '操作人',
          opTimeLabel: '操作时间'
        },
        {
          id: 'inbound',
          title: '入库',
          opUserLabel: '操作人',
          opTimeLabel: '操作时间'
        },
        {
          id: 'complete',
          title: '完成',
          opUserLabel: '操作人',
          opTimeLabel: '操作时间'
        },
      ];
      if (this.viewOpType || this.editOpType) {
        this.loading.content = true;
        Promise.all([
          getPurchaseOrder(this.purchaseOrder.id),
          getPurchaseOrderProductList(this.purchaseOrder.id),
          getPurchaseOrderProcessList(this.purchaseOrder.id),
        ])
          .then(([data, products, processList]) => {
            this.initing = true;
            this.data = data;
            Object.assign(this.form, data);
            this.setCompanyInfo(this.companyInfo)
            this.form.products = products;
            this.setconsignee({
              consignee: this.data.consigneeName,
              consigneeTel: this.data.phone,
              consigneeAddress: this.data.receiptAddress
            })
            // 设置附件
            if (data.attachments) {
              this.form.files = data.attachments.map(item => ({
                name: item.fileName,
                attId: item.id,
              }));
            }
            // 设置流程节点
            if (this.purchaseOrder.status === StatusEnum.ABOLISHED) {
              const prefix = {
                create: '创建',
                review: '审核'
              };
              this.steps = processList.map(item => {
                const label = prefix[item.processNode] ? prefix[item.processNode] : '操作';
                return {
                  descriptionTpl: item.processNode,
                  title: item.processContent,
                  opUserLabel: `${label}人`,
                  opUserContent: item.updateUser,
                  opTimeLabel: `${label}时间`,
                  opTimeContent: item.updateTime
                };
              });
              this.curStep = processList.length === this.steps.length
                ? this.steps.length
                : processList.length;
            } else if (this.purchaseOrder.status === StatusEnum.REJECTED) {
              normalSteps[1].id = 'reviewPass';
              normalSteps[1].title = '审核驳回';
              this.steps = normalSteps;
              processList.forEach(item => {
                const step = this.steps.find(step => step.id === item.processNode);
                if (step) {
                  step.descriptionTpl = item.processNode;
                  step.opUserContent = item.updateUser;
                  step.opTimeContent = item.updateTime;
                }
              });
              this.curStep = processList.length;
            } else {
              this.steps = normalSteps;
              processList.forEach(item => {
                const step = this.steps.find(step => step.id === item.processNode);
                if (step) {
                  step.descriptionTpl = item.processNode;
                  step.opUserContent = item.updateUser;
                  step.opTimeContent = item.updateTime;
                }
              });
              this.curStep = processList.length === this.steps.length
                ? this.steps.length
                : processList.length;
            }
            setTimeout(() => this.initing = false);
          })
          .complete(() => this.loading.content = false);
      }
      if (this.addOpType) {
        this.curStep = 0;
        this.steps = normalSteps;
      }
      if (this.companyInfo.length) {
        this.setCompanyInfo(this.companyInfo)
      } else {
        this.$store.dispatch(GET_COMPANY_INFO).then(() => {
          this.companyInfo.length && this.setCompanyInfo(this.companyInfo)
        })
      }
    },
    methods: {
      consigneeNameChange() {
        const instance = this.companyInfo.find(v => v.consignee === this.form.consigneeName)
        instance && this.setconsignee(instance)
      },
      setCompanyInfo(info = []) {
        if (info.length) {
          this.form.companyName = info[0].companyName
        }
      },
      setconsignee(info) {
        this.form.consigneeName = info.consignee || ''
        this.form.phone = info.consigneeTel || ''
        this.form.receiptAddress = info.consigneeAddress || ''
      },
      download(fileId) {
        downloadAttFile(fileId);
      },
      saveAsDraft() {
        if (this.formValidate()) {
          this.loading.saveAsDraft = true;
          Promise.resolve()
            .then(() => {
              if (this.addOpType) {
                return savePurchaseOrder(this.formParams)
              }
              if (this.editOpType) {
                return updatePurchaseOrder(this.formParams)
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                if (this.addOpType) {
                  this.$gjMessage.success('保存成功');
                  this.$emit('created');
                }
                if (this.editOpType) {
                  this.$gjMessage.success('保存成功');
                  this.$emit('updated');
                }
                this.$gjDestroy();
              })
            })
            .complete(() => this.loading.saveAsDraft = false);
        }
      },
      // 设置公司
      settingCompany() {
        this.$router.push({
          name: 'personal-center-mine',
          params: {
            isRouter: true
          }
        })
      },
      saveAndAudit() {
        if (this.formValidate()) {
          this.loading.saveAndAudit = true;
          Promise.resolve()
            .then(() => {
              if (this.addOpType) {
                return saveAndAuditPurchaseOrder(this.formParams)
              }
              if (this.editOpType) {
                return updateAndAuditPurchaseOrder(this.formParams)
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                if (this.addOpType) {
                  this.$gjMessage.success('提审成功');
                  this.$emit('created');
                }
                if (this.editOpType) {
                  this.$gjMessage.success('提审成功');
                  this.$emit('updated');
                }
                this.$gjDestroy();
              })
            })
            .complete(() => this.loading.saveAndAudit = false);
        }
      },
      audit() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '提审确认',
            content: `确定要提审[${this.purchaseOrder.code}]吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              auditPurchaseOrder({
                idList: [this.purchaseOrder.id],
              })
                .then(res => {
                  this.handleResponse(modal, res, '操作成功');
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      deleteItem() {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `作废<span class="modal-secondary-title">${this.purchaseOrder.code}</span>`,
            label: '作废理由',
            labelWidth: '75px',
            contentStyle: {padding: '16px 20px 0 20px'},
            notMargin: true
          },
          on: {
            submit: (memo) => {
              modal.confirmLoading = true;
              cancelPurchaseOrder({
                id: this.purchaseOrder.id,
                memo,
              })
                .then(res => {
                  this.handleResponse(modal, res, '操作成功');
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      fail() {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `驳回<span class="modal-secondary-title">${this.purchaseOrder.code}</span>`,
            label: '驳回理由',
            labelWidth: '75px',
            contentStyle: {padding: '18px 40px 4px 30px'}
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              auditFailPurchaseOrder({
                idList: [this.purchaseOrder.id],
                reason,
              })
                .then(res => {
                  this.handleResponse(modal, res, '操作成功');
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      pass() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: `确定要通过[${this.purchaseOrder.code}]吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              auditPassPurchaseOrder({
                idList: [this.purchaseOrder.id],
              })
                .then(res => {
                  this.handleResponse(modal, res, '操作成功');
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      purchase() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: `确认下单？该采购订单状态更新为“待交货”！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              purchasePurchaseOrder({
                idList: [this.purchaseOrder.id],
              })
                .then(res => {
                  this.handleResponse(modal, res, '操作成功');
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      purchaseChange() {
        this.$gjCreate(AppPurchaseChangeModal, {
          props: {
            purchaseOrder: this.purchaseOrder
          },
          on: {
            created: () => {
              this.$emit('resetPage');
              this.$gjDestroy();
            }
          }
        })
      },
      exportContract() {
        exportFile(`/supply/purchaseOrder/export/contract/${this.purchaseOrder.id}`);
      },
      endDelivery() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '结束交货确认',
            content: `确定要结束交货？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              endDeliveryPurchaseOrder({
                idList: [this.purchaseOrder.id],
              })
                .then(res => {
                  this.handleResponse(modal, res, '操作成功');
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      fastInbound() {
        this.$gjCreate(AppFastInboundModal, {
          props: {
            purchaseOrders: [this.purchaseOrder]
          },
          on: {
            created: () => {
              this.$emit('resetPage');
              this.$gjDestroy();
            }
          }
        });
      },
      createDeliveryOrder() {
        this.$gjCreate(AppCreateDeliveryOrderModal, {
          props: {
            purchaseOrders: [this.purchaseOrder]
          },
          on: {
            created: () => {
              this.$emit('resetPage');
              this.$gjDestroy();
            }
          }
        });
      },
      handleResponse(modal, res, message) {
        this.$gjResponseHandle(res, () => {
          this.$gjMessage.success(message);
          this.$emit('resetPage');
          modal.$gjDestroy();
          this.$gjDestroy();
        });
      },
      formValidate() {
        return this.$gjFormValidate()
          && this.$refs['productForm'].formValidate();
      }
    }
  }
</script>

<style scoped lang="scss">
  .header {
    display: inline-block;
    margin-right: 8px;
  }
  .step-wrapper {
    padding: 0 20px 10px;
    margin-bottom: 10px;
    //border-bottom: 1px solid #EBEEF5;
  }
  /deep/ .gj-modal--custom .el-dialog {
    height: 100%;
    width: 1300px;
  }
  /deep/ .el-step__title, /deep/ .el-step__description{
    margin-left: -5px;
  }
  /deep/ .el-tabs__item{
    font-size: 13px;
    &.is-active{
      font-weight: bold;
    }
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  /deep/ .gj-table{
    padding-bottom: 1px;
  }
  .view-form{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 24px;
    }
  }
  .settting-companyName_icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 5px;
    font-size: 16px;
    cursor: pointer;
    color: #999;
  }
  .op-purchase-order-modal_logtable {
    /deep/ .gj-table{
      height: auto !important;
    }
  }
</style>

